import { render } from "./lenseglass.vue?vue&type=template&id=025a7e08"
import script from "./lenseglass.vue?vue&type=script&lang=js"
export * from "./lenseglass.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__